import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ViewCell} from '../../ng2-smart-table';

// Ref https://akveo.github.io/ng2-smart-table/#/examples/custom-editors-viewers
@Component({
  selector: 'app-bucketwise-settings-icon',
  template: `
    <a class="text-decoration-none" ngbTooltip="Summary of emails sent in a day." (click)="onDetailsClick()" style="margin-right:24px"><i class="nxticon-generic_document nxt-font-20"></i></a>
    <a class="text-decoration-none" ngbTooltip="Download reports" (click)="onDownloadClick()"><i class="nxticon-download nxt-font-16"></i></a>
  `,
  styles: []
})
export class BucketwiseSettingsIconComponent implements ViewCell, OnInit {

  renderValue: string;

  @Input() value: string | number;
  @Input() rowData: any;

  @Output() detailsClick: EventEmitter<any> = new EventEmitter();
  @Output() downloadClick: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.renderValue = this.value.toString();
  }

  onDetailsClick() {
    this.detailsClick.emit(this.rowData);
  }

  onDownloadClick() {
    this.downloadClick.emit(this.rowData);
  }

}
